import IdealniNajemce from "scenes/LandingPage/IdealniNajemce";
import { CustomAppPage } from "src/types/types";

const IdealniNajemcePage: CustomAppPage = () => <IdealniNajemce />;

IdealniNajemcePage.hasHiddenFooter = true;

export default IdealniNajemcePage;
